import type { SignatureField } from '@corner/shared';

/**
 * True when a marker is meant for an invitee (recipient), not the sender.
 * Placement uses legend slot index ≥1 for "Recipient" / additional signers and
 * roles like `other_signature`; do not rely only on party/signer — those can be
 * missing or out of sync while `role` still starts with `other_`.
 */
export function isRecipientPlacementField(f: SignatureField): boolean {
  if (f.party === 'other' || f.signer === 'other') return true;
  const idx = f.assignedSignerIndex;
  if (typeof idx === 'number' && idx >= 1) return true;
  const r = (f.role ?? '').toLowerCase();
  if (r.startsWith('other_')) return true;
  return false;
}
